import { render, staticRenderFns } from "./bulkNotification.vue?vue&type=template&id=b939cd42"
import script from "./bulkNotification.vue?vue&type=script&lang=js"
export * from "./bulkNotification.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports